import type { ManualVariable } from '../triggerWorkflowTypes';
import { parseWorkflowDefinitionString } from '../workflowDefinitionSerialize';

export type ParsedTriggerForTestRun =
  | { status: 'ok'; triggerLabel: string; variables: ManualVariable[] }
  | { status: 'no_definition' }
  | { status: 'parse_error' }
  | { status: 'no_trigger' }
  | { status: 'not_manual'; triggerLabel: string; triggerKind: string };

export function parseTriggerInputsForTestRun(definitionJson: string): ParsedTriggerForTestRun {
  if (!definitionJson?.trim()) return { status: 'no_definition' };
  const parsed = parseWorkflowDefinitionString(definitionJson);
  if (!parsed) return { status: 'parse_error' };
  const trigger = parsed.nodes.find((n) => n.type === 'triggerNode');
  if (!trigger) return { status: 'no_trigger' };
  const data = trigger.data as Record<string, unknown>;
  const label = typeof data.label === 'string' && data.label.trim() ? data.label.trim() : 'Trigger';
  const settings = data.settings as { kind?: string; variables?: unknown } | undefined;
  if (!settings || settings.kind !== 'manual') {
    const kind =
      typeof data.triggerKind === 'string'
        ? data.triggerKind
        : typeof settings?.kind === 'string'
          ? settings.kind
          : 'unknown';
    return { status: 'not_manual', triggerLabel: label, triggerKind: kind };
  }
  const raw = Array.isArray(settings.variables) ? settings.variables : [];
  const variables = raw
    .filter((v): v is ManualVariable => Boolean(v) && typeof v === 'object' && typeof (v as ManualVariable).name === 'string')
    .map((v) => ({
      name: String(v.name).trim(),
      type: typeof v.type === 'string' && v.type.trim() ? v.type.trim() : 'string',
    }))
    .filter((v) => v.name.length > 0);
  return { status: 'ok', triggerLabel: label, variables };
}
